import { render, staticRenderFns } from "./GroupSiteRestrictions.vue?vue&type=template&id=6b89e0bd&"
import script from "./GroupSiteRestrictions.vue?vue&type=script&lang=js&"
export * from "./GroupSiteRestrictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports